import type { Queryfilter as QueryFilter } from '@gonfalon/queryfilter/builder';
import { and, anyOf, contains, equals, toString as queryfilterToString } from '@gonfalon/queryfilter/builder';

import type { GetViewsOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export type GetViewsQueryParams = Omit<GetViewsOpenAPIQueryParams, 'filter'> & {
  filter?: {
    query?: string;
    tags?: string[];
    isPayloadView?: boolean;
    maintainerId?: string[];
    // only used on the FE
    type?: 'flags' | 'segments' | 'metrics' | 'ai-configs' | 'all';
  };
};

export function querySerializer(queryParams: GetViewsQueryParams) {
  const searchParams = new URLSearchParams();

  if (queryParams.filter) {
    const serializedFilter = serializeGetViewsFilterParam(queryParams.filter);
    if (serializedFilter) {
      searchParams.set('filter', serializedFilter);
    }
  }

  if (queryParams.expand) {
    searchParams.set('expand', queryParams.expand.join(','));
  }

  if (queryParams.sort) {
    searchParams.set('sort', queryParams.sort);
  }

  if (queryParams.limit) {
    searchParams.set('limit', queryParams.limit.toString());
  }
  if (queryParams.offset) {
    searchParams.set('offset', queryParams.offset.toString());
  }

  if (queryParams.filter?.type) {
    // do nothing as this is only used on the FE
  }

  return searchParams.toString();
}

export function serializeGetViewsFilterParam(value: GetViewsQueryParams['filter']) {
  const filter: QueryFilter[] = [];

  if (value?.query) {
    filter.push(contains('name', [value.query]));
  }

  if (value?.tags && value.tags.length > 0) {
    filter.push(anyOf('tag', value.tags));
  }

  if (value?.isPayloadView) {
    filter.push(equals('isPayloadView', value.isPayloadView));
  }

  if (value?.maintainerId && value.maintainerId.length > 0) {
    filter.push(anyOf('maintainerId', value.maintainerId));
  }

  return queryfilterToString(and(filter));
}
